import './App.css';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './Pages/Home/Home';
// import FirstProject from './Components/ProjectsDescription/FirstProject';
// import SecondProject from './Components/ProjectsDescription/SecondProject';
// import ThirdProject from './Components/ProjectsDescription/ThirdProject';
// import Blogs from './Components/Blogs/Blogs';
import { createContext, useState } from 'react';
import Header from './Shared/Header';
import Footer from './Shared/Footer';
import Projects from './Pages/Projects/Projects';
import UIUX from './Pages/Projects/UIUX';
  // const { projectCategory } = useParams();
export const darkModeContext = createContext()

function App() {
  const [dark, setDark] = useState(true)
  
  return (
    <darkModeContext.Provider value={{ dark, setDark }}>
      <div className={`App ${dark === true ? "dark" : ""}`}>
        {/* to-[1E1B2E] from-[0A0A0A] from-[0D1117] from-[1c1c1e] to-[0F172A] to-[1A1A1A] bg-gradient-to-br from-[#0f172a] via-[#0D1B2A] to-[#1E3A8A] */}

        <div className="w-full dark:bg-[#0a0f16] dark:text-white min-h-[100vh]">
          <div className="pointer-events-none fixed inset-0 opacity-30">
            <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
              <filter id="noise">
                <feTurbulence
                  type="fractalNoise"
                  baseFrequency="1"
                  numOctaves="4"
                  stitchTiles="stitch"
                />
              </filter>
              <rect
                width="100%"
                height="100%"
                filter="url(#noise)"
                opacity="0.15"
              />
            </svg>
          </div>
          <div className="">
            {/* {projectCategory != "uiux" && <Header />} */}
            {/*---------------MASS BG--------*/}
            {/* <div className="mass-bg">
              <div className="absolute inset-0 justify-center">
                <div className="bg-shape1 bg-primary opcity-50 bg-blur"></div>
                <div className="bg-shape2 bg-teal opcity-50 bg-blur"></div>
                <div className="bg-shape3 bg-purple opcity-50 bg-blur"></div>
              </div>
            </div> */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/project/uiux" element={<UIUX />} />
              <Route path="/project/:projectCategory" element={<Projects />} />
              
              {/* <Route path='/home' element={<Home />} />
          <Route path='/blogs' element={<Blogs />} />
          <Route path='/project/thecarz' element={<FirstProject />} />
          <Route path='/project/electroenventory' element={<SecondProject />} />
          <Route path='/project/gymtrainer' element={<ThirdProject />} /> */}
            </Routes>
            <ToastContainer />
            
          </div>
        </div>
      </div>
    </darkModeContext.Provider>
  );
}

export default App;
